import { useMemo } from 'react';
import { WORKFLOW_OPTIONS } from '@ubeya/shared/constants/sequences';

const WORKFLOW_KINDS = {
  GENERAL: 0,
  COMPLIANCE: 1,
  TIMESHEET: 2
};

const useSequencePayload = ({ kind }) => {
  const payload = useMemo(() => {
    switch (kind) {
      case WORKFLOW_KINDS.COMPLIANCE:
        return {
          title: 'compliances',
          path: 'compliances',
          slug: {
            notification: 'complianceNotification',
            emptyState: 'noCompliances',
            myContent: 'myContentCompliance',
            addNewOne: 'addCompliance',
            newOne: 'newCompliance',
            publish: 'publishCompliance',
            areYouSureYouWantToDelete: 'areYouSureYouWantToDeleteCompliance',
            name: 'complianceName',
            isPrompt: 'complianceIsPrompt',
            edit: 'editCompliance',
            areYouSureYouWantToPublish: 'areYouSureYouWantToPublishCompliance',
            editingPublishedWarning: 'editingPublishedComplianceWarning',
            general: 'complianceGeneral',
            description: 'complianceDescription'
          }
        };

      case WORKFLOW_KINDS.TIMESHEET:
        return {
          title: 'timesheetSequences',
          path: 'timesheet-sequences',
          type: WORKFLOW_OPTIONS.TIMESHEET,
          slug: {
            notification: 'timesheetSequenceNotification',
            emptyState: 'noTimesheetSequences',
            myContent: 'myContentTimesheetSequence',
            myContentTooltip: 'myContentTimesheetSequenceTooltip',
            addNewOne: 'addTimesheetSequence',
            newOne: 'newTimesheetSequence',
            areYouSureYouWantToDelete: 'areYouSureYouWantToDeleteTimesheetSequence',
            name: 'timesheetSequenceName',
            isPrompt: 'timesheetSequenceIsPrompt',
            isPermanent: 'timesheetSequenceIsPermanent',
            edit: 'editTimesheetSequence',
            editingPublishedWarning: 'editingPublishedTimesheetWorkflowWarning',
            general: 'timesheetSequenceGeneral',
            description: 'timesheetSequenceDescription',
            publish: 'sequenceTimesheetPublish',
            published: 'sequenceTimesheetPublished',
            notPublished: 'sequenceTimesheetNotPublished',
            pausedPublication: 'sequenceTimesheetPaused',
            pausePublication: 'sequenceTimesheetPause',
            resumePublication: 'sequenceTimesheetResume',
            areYouSureYouWantToPauseSequence: 'areYouSureYouWantToPauseTimesheetSequence',
            areYouSureYouWantToResumeSequence: 'areYouSureYouWantToResumeTimesheetSequence',
            areYouSureYouWantToPublish: 'areYouSureYouWantToPublishTimesheetSequence',
            tooltipMainContent: 'mainDescriptionNotificationToFillTheTask',
            tooltipPositiveValueContent: 'positiveValueDescriptionNotificationToFillTheSequence',
            tooltipNegativeValueContent: 'negativeValueDescriptionNotificationToFillTheSequence'
          }
        };

      default:
        return {
          title: 'sequences',
          path: 'sequences',
          slug: {
            notification: 'sequenceNotification',
            emptyState: 'noSequences',
            myContent: 'myContentSequence',
            addNewOne: 'addSequence',
            newOne: 'newSequence',
            publish: 'publishSequence',
            areYouSureYouWantToDelete: 'areYouSureYouWantToDeleteSequence',
            areYouSureYouWantToPublish: 'areYouSureYouWantToPublishSequence',
            name: 'sequenceName',
            isPrompt: 'sequenceIsPrompt',
            isPermanent: 'sequenceIsPermanent',
            edit: 'editSequence',
            editingPublishedWarning: 'editingPublishedWorkflowWarning',
            general: 'sequenceGeneral',
            description: 'sequenceDescription',
            tooltipMainContent: 'mainDescriptionNotificationToFillTheSequence',
            tooltipPositiveValueContent: 'positiveValueDescriptionNotificationToFillTheSequence',
            tooltipNegativeValueContent: 'negativeValueDescriptionNotificationToFillTheSequence'
          }
        };
    }
  }, [kind]);

  return payload;
};

export default useSequencePayload;
